export default "__VITE_ASSET__e397ed5c__"